<template>
  <div>
    <div class="f-h"></div>
    <div class="footer">
      <div class="f-a">
        <router-link to="/" exact >
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-zhuye"></use>
              </svg>
            </span>
          <p>首页</p>
        </router-link>
      </div>
      <!-- <div class="f-a">
        <router-link to="/agency/index">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-liuliangyunpingtaitubiao03"></use>
              </svg>
            </span>
          <p>代理</p>
        </router-link>
      </div> -->
      <div class="f-a">
        <router-link to="/retails/index">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-lingshouliushuizhangledger"></use>
              </svg>
            </span>
          <p>推广</p>
        </router-link>
      </div>
      <div class="f-a">
        <router-link to="/users/index">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-wode"></use>
              </svg>
            </span>
          <p>我的</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: ''
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue